/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import FilePickerButton from '../../components/buttons/FilePickerButton';
import {
  isMobileApplication,
} from '../../../utilities/MobileUtil';

import { useNavigate } from '../../hooks/useNavigate';
import FileActions from '../../appAuthorized/redux/FileActions';
import RouteNames from '../../appAuthorized/RouteNames';
import AppNavFilePreview from './components/AppNavFilePreview';
import ContentWrapper from '../../components/ContentWrapper';
import { Icons, Card } from '../../../bphComponents/bundle';
import COLORS from '../../styles/Colors';

const FileUploadErrorTooBig = props => {
  const { intl } = props;
  const [, navActions] = useNavigate();

  return (
    <div className="cmp-fileview__content-area">
      <AppNavFilePreview
        done={{
          onClick: () => {
            navActions.goBack(RouteNames.myBackpackFiles());
          },
        }}
      />

      <div className="cmp-filepreview__missing">
        <ContentWrapper>
          <Card.CardContent disabledPadding={['bottom']}>
            <div style={{ marginBottom: 24 }}>
              <Icons.IconWarning.XLarge color={COLORS.gsDark} />
            </div>

            <div className="font-subhead color-gsDarkest">
              <FormattedMessage id="fileUploadInvalid.error.message.text" />
            </div>
          </Card.CardContent>

          <FilePickerButton
            style={{ maxWidth: 312, textAlign: 'center' }}
            sourceType="library"
            onChange={
              isMobileApplication()
                ? (newRawFile) => {
                  FileActions.rawFileSelected(newRawFile);
                  navActions.replace(RouteNames.fileUpload());
                  SpinnerDialog.hide();
                } : (newRawFile) => {
                  FileActions.rawFileSelected(newRawFile);
                  navActions.replace(RouteNames.fileUpload());
                }
            }
            onError={() => {
              SpinnerDialog.hide();
            }}
          >
            <div className="font-title-3 font-color-gsLightest">
              <FormattedMessage id="fileUploadInvalid.addAnotherFile.button.label" />
            </div>
          </FilePickerButton>
        </ContentWrapper>
      </div>

      <div />
    </div>
  );
};

export default injectIntl(FileUploadErrorTooBig);
